import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { getFirstAvailableSideMenuLink } from "helpers";
import { userActions } from "store";

const RedirectToAvailableSideMenuItem = () => {
	const dispatch = useDispatch<(thunk: () => Promise<any>) => Promise<any>>();
	const history = useHistory();

	useEffect(() => {
		dispatch(userActions.getPermissions({ fromStore: true })).then(() => {
			history.push(getFirstAvailableSideMenuLink()?.to || "/");
		});
	}, [dispatch, history]);
};

export default RedirectToAvailableSideMenuItem;
